var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CEESAR-Link",on:{"click":_vm.OnClick}},[_c('div',{staticClass:"CEESAR-LinkLabel"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }